import { FC } from 'react';
import { SigninComponent } from './SigninComponent/SigninComponent';

export const SigninPage: FC = () => {
  return <SigninComponent />;
};
